import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loading, PageTitle } from "@/components/States";
import { card } from "@/lib/ui";

export default function Rules() {
  const [r, setR] = useState(null);
  useEffect(() => {
    api.get("/rules").then(({ data }) => setR(data)).catch(() => setR({}));
  }, []);
  if (!r) return <Loading />;
  const items = [
    ["Listings stay fresh", `Sellers reconfirm availability every ${r.stale_days} days. Unconfirmed listings pause until reconfirmed.`],
    ["Offers don't reserve items", `An accepted offer holds its price for ${r.offer_hold_hours} hours. Only a pickup confirmed by both people reserves the item.`],
    ["One reservation per item", `A confirmed pickup reserves the item until ${r.reservation_grace_hours} hours after the pickup time. Others can join the waitlist.`],
    ["Same details, both agree", "A pickup is confirmed only when both people agree to the same price, time and place. Any change needs renewed agreement."],
    ["Cancellations", `Cancelling a confirmed pickup at least ${r.late_cancel_hours} hours ahead is an advance cancellation; later is a late cancellation. Buyers aren't penalized when an item differs materially from its description.`],
    ["What never counts against you", "Browsing, asking questions, declined offers, and choosing not to buy an item that differs from its listing."],
    ["Outcomes", `After a pickup, both people confirm whether it happened and whether it sold. Mismatched or missing answers after ${r.outcome_window_hours} hours are marked unresolved — never a made-up sale.`],
    ["Ratings", `Only mutually confirmed sales can be rated. Ratings publish once both people submit or after ${r.review_window_days} days.`],
    ["No-show reports", `A single report never changes reputation automatically. The reported person has ${r.dispute_response_hours} hours to respond, an admin reviews both sides, and decisions can be appealed within ${r.appeal_window_days} days.`],
    ["Repeated no-shows", `${r.no_show_warning_threshold} substantiated no-shows within ${r.no_show_lookback_days} days triggers a warning; ${r.no_show_restriction_threshold} limits new bookings for ${r.restriction_days} days. FollowThrough never fines anyone.`],
    ["Metrics need real history", `Reliability and response time appear only after ${r.min_sample_for_metrics} data points, and always show sample sizes. New users show "New member."`],
  ];
  return (
    <div className="max-w-2xl">
      <PageTitle sub="These rules are applied automatically and configured by our trust team.">Community rules & coverage</PageTitle>
      <div className="space-y-3">
        {items.map(([t, b], i) => (
          <div key={t} data-testid={`rule-${i}`} className={card}>
            <p className="font-bold text-slate-900">{t}</p>
            <p className="text-sm text-slate-600 mt-1">{b}</p>
          </div>
        ))}
      </div>
      <div data-testid="coverage-section" className={card + " mt-6"}>
        <p className="font-bold text-slate-900">Where FollowThrough works</p>
        <p className="text-sm text-slate-600 mt-1">Anywhere in the US. Buyers and sellers use any US ZIP code. Distances are approximate, from ZIP centers — never home addresses.</p>
      </div>
    </div>
  );
}
